import "./PersonalDataProtectionAndProcessingPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicy from "./sections/PrivacyPolicy";
import Footer from "@/reusable_sections/Footer";
export default function PersonalDataProtectionAndProcessingPolicyPage() {
  return <div>
      <Header />
      <PrivacyPolicy />
      <Footer />
    </div>;
}